/* eslint-disable max-lines */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { post, get } from './utils/http'

import HeaderBar from './components/headerBar.vue'
import FooterBar from './components/footerbar.vue'
import FooterBarTwo from './components/footerbarTwo.vue'
import tabBar from './components/tabBar.vue'
import authInfoBar from './components/authInfoBar.vue'

import ElementPlus from 'element-plus'
//import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import {WarningFilled} from '@element-plus/icons-vue'
import DatePicker from 'vuejs3-datepicker';
import '../static/theme/index.css'
import moment from 'moment'
import common from './utils/common'

import CardOrder from "@/components/card/CardOrder/index.vue"
import ConfirmModal from '@/components/Modal/ConfirmModal.vue'
import store from '@/store/store';

import VueGoogleMaps from '@fawmi/vue-google-maps'

import userApi from './api/user.js'

// Create the Vue application instance
const app = createApp(App)

const commonClass = new common()
app.use(store);
app.component('WarningFilled', WarningFilled);
// for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
//   app.component(key, component)
// }
// Use Vue Google Maps plugin with configuration
app.use(VueGoogleMaps, {
  load: {
    key: process.env.API_KEY_MAP, // Your Google Maps API key
    libraries: 'places'           // Specify the libraries you need
  }
})

// Register global components
app.component('HeaderBar', HeaderBar)
app.component('FooterBar', FooterBar)
app.component('FooterBarTwo', FooterBarTwo)
app.component('tabBar', tabBar)
app.component('authInfoBar', authInfoBar)
app.component('CardOrder', CardOrder)
app.component('ConfirmModal', ConfirmModal)
app.component('datepicker', DatePicker)

// Register Element Plus UI library
app.use(ElementPlus)

// Define global properties for post, get methods, and common utils
app.config.globalProperties.$post = post
app.config.globalProperties.$get = get
// app.config.globalProperties.$common = new common()

// Register global filters (for use within templates)
app.config.globalProperties.$filters = {
  // Format numbers with commas
  NumFormat(value) {
    if (!value) return 0
    if (isNaN(Number(value))) return value
    const intPart = Number(value).toFixed(0)
    const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
    return intPartFormat
  },
  // Convert a number to string format with commas
  NumFormatToString(value) {
    if (!value) return 0
    if (isNaN(Number(value))) return value
    const intPart = value.toString()
    const intPartFormat = intPart.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
    return intPartFormat
  },
  // Format dates using Moment.js
  dateFmt(input, formatString = 'YYYY/MM/DD') {
    return moment(input).format(formatString)
  },
  dateFormatStr(input, formatString = 'YYYY年M月D日') {
    return moment(input).format(formatString)
  },
  // Translate export status to human-readable strings
  exportStatus(value) {
    if (!value) return ''
    switch (value) {
      case 1:
        return '処理中'   // Processing
      case 2:
        return '受注済み' // Ordered
      case 3:
        return '注文キャンセル' // Order Canceled
      default:
        return ''
    }
  }
}

// Use the router and initialize the application
app.use(router)
/** LINE アプリ内ブラウザか（未初期化・外部ブラウザでは false） */
function isLiffInClient () {
  try {
    return typeof liff !== 'undefined' && typeof liff.isInClient === 'function' && liff.isInClient()
  } catch {
    return false
  }
}

/** 外部ブラウザで領収書保存用に開くパス（extbrowser へリダイレクトしない） */
function isReceiptDownloadBypassPath (path) {
  return path === '/receipt-download.html'
    || path === '/static/receipt-download.html'
    || path === '/receipt-download'
}

// Mount the application to the DOM
app.mount('#app')
// Logic to handle route changes
router.beforeEach((to, from, next) => {
  let appUrl =  "https://miniapp.line.me/" + process.env.VUE_APP_LIFF_ID + "/home";
  const currentVersion = "20260226";
  //const storedVersion = localStorage.getItem('version');
  // Check version on home page
  if ((to.path === '/home' || to.path === '/' || to.path === '') && to.query.v === undefined) {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('v', currentVersion);
    window.location.href = currentUrl.toString();
    return;
  }

  localStorage.setItem('version', currentVersion);
  let toFullPath = to.fullPath
  if (!isLiffInClient()) {
    if (to.path == "/privacypolicy") {
      next();
    } else if (to.path == "/extbrowser") {
      next();
    } else if (isReceiptDownloadBypassPath(to.path)) {
      next();
    } else {
      next("/extbrowser");
    }
    return
  }

  setUrlParamToSessionStorage(decodeURIComponent(decodeURIComponent(toFullPath)))

  // Set the document title based on the route's meta information
  if (to.meta.title) {
    document.title = to.meta.title
  }

  // Check if the route requires storeId in sessionStorage
  if (to.meta.checkStoreId && !sessionStorage.getItem('storeId')) {
    return next('/')
  }

  // Check if the route requires authentication
  if (!to.matched.some(record => record.meta.authless)) {
    let openId = sessionStorage.getItem('openId')

    // Development environment logic
    if (process.env.NODE_ENV === 'development') {
      openId = 'U1ed862e02348de5d8400bd65b60d8bba'
      sessionStorage.setItem('platformId', process.env.VUE_APP_LIFF_ID)
      sessionStorage.setItem('openId', openId)

      let userAuthInfoJson = sessionStorage.getItem('userAuthInfo')

      // If userAuthInfo is not available, set default information
      if (!userAuthInfoJson) {
        let userAuthInfo = {
          openId: openId,
          userImg: 'https://profile.line-scdn.net/0hWOQ2INTLCGB8SyMBOsB2HwwbCwpfOlFyVSoSAh0YXlASexw2WX1EAk9DBQUUfUpjBy1BURkZUwVwWH8GYh30VHt7VldFfEk0WC9EhQ',
          userName: 'マキ'
        }
        sessionStorage.setItem('userAuthInfo', JSON.stringify(userAuthInfo))
      }
      // Retrieve store information
      getSysMStore()
      // Redirect and initialize member info
      checkIsEatIn(to, next)
      redirectInitMember(openId, next)
    } else {
      // Production logic for LIFF authentication and initialization
      let liffStateUrlKey = 'liff.state'
      let liffStateUrl = to.query[liffStateUrlKey]
      if (!liffStateUrl) {
        liffStateUrl = sessionStorage.getItem(liffStateUrlKey)
        liffStateUrl = decodeURIComponent(liffStateUrl)
        liffStateUrl = decodeURIComponent(liffStateUrl)
        setUrlParamToSessionStorage(liffStateUrl)
      }

      getSysMStore()
      if (!store.state.index.isLoggedIn) {
        liff
          .init({ liffId: process.env.VUE_APP_LIFF_ID })
          .then(() => {
            liffLogin(liff, to)
            store.dispatch('setLoggedIn', true)
          })
          .then(async () => {
            await getProfile(to, next)
          })
          .catch((err) => {
            router.push({name: 'autherror'})
          })
      } else {
        if (!sessionStorage.getItem('userAuthInfo')) {
          getProfile(to, next)
        } else {
          checkIsEatIn(to, next)
        }
      }
    }
  } else {
    next()
  }
})

async function checkIsEatIn (to, next) {
  console.log(to, next)
  const listName = ['goods_category_v2', 'goodsList_v2', 'good_detail', 'cart_v2', 'pay_v2']
  const isEatInSs = sessionStorage.getItem('isEatIn')
  const storeIdSs = sessionStorage.getItem('storeId')
  if (to && to.name) {
    if (listName.includes(to.name) && (isEatInSs == null || isEatInSs == undefined) && storeIdSs) {
      const hasStoreIdInPath = typeof to.fullPath === 'string' && /\/goodsCategory\?.*storeId=/.test(to.fullPath)
      let hasStoreIdInLiffState = false
      const liffState = to.query?.['liff.state']
      if (typeof liffState === 'string' && liffState) {
        try {
          const decodedLiffState = decodeURIComponent(decodeURIComponent(liffState))
          hasStoreIdInLiffState = /\/goodsCategory\?.*storeId=/.test(decodedLiffState)
        } catch (e) {
          hasStoreIdInLiffState = /\/goodsCategory\?.*storeId=/.test(liffState)
        }
      }
      const isScanEntryToGoodsCategory = to.name === 'goods_category_v2' && (hasStoreIdInPath || hasStoreIdInLiffState)
      if (isScanEntryToGoodsCategory) {
        sessionStorage.setItem('showWelcomeOnStoreUseType', 'true')
      }
      next('/storeUseType')
    } else {
      next()
    }
  }
}

// Function to store URL parameters in sessionStorage
function setUrlParamToSessionStorage (url, startIndex) {
  if (url) {
    if (startIndex === undefined || startIndex === null) {
      startIndex = 1
    }
    let queryUrlParamArray = url.split('?')
    if (queryUrlParamArray && queryUrlParamArray.length > startIndex) {
      let urlParamArray = queryUrlParamArray[startIndex].split('&')
      for (let key in urlParamArray) {
        let paramKeyValArray = urlParamArray[key].split('=')
        if (paramKeyValArray && paramKeyValArray.length > 1) {
          sessionStorage.setItem(paramKeyValArray[0], paramKeyValArray[1])
        }
      }
    }
  }
}

// Function to initialize member info and redirect if necessary
function redirectInitMember (openId, next) {
  let userAuthInfoJson = sessionStorage.getItem('userAuthInfo')
  if (userAuthInfoJson) {
    let userAuthInfo = JSON.parse(userAuthInfoJson)
    if (userAuthInfo && !userAuthInfo.memberId) {
      initMember(userAuthInfo, next)
    } else {
      next()
    }
  } else {
    let userAuthInfo = {}
    userAuthInfo.platformId = process.env.VUE_APP_LIFF_ID
    userAuthInfo.openId = openId
    initMember(userAuthInfo, next)
  }
}

// Function to handle LIFF login
async function liffLogin (liff, to) {
  if (!liff.isLoggedIn()) {
    let liffStateUrl = to.query['liff.state']
    let liffRedirectUri = process.env.ENDPOINT_URL + (liffStateUrl ? liffStateUrl : '')
    if (liffRedirectUri) {
      liffRedirectUri = decodeURIComponent(liffRedirectUri)
      liffRedirectUri = decodeURIComponent(liffRedirectUri)
      await liff.login({ redirectUri: liffRedirectUri })
    } else {
      await liff.login()
    }
  }
}

// Function to get user profile after login
async function getProfile (to, next) {
  let userAuthInfoJson = sessionStorage.getItem('userAuthInfo')
  if (userAuthInfoJson) {
    let userAuthInfo = JSON.parse(userAuthInfoJson)
    if (userAuthInfo && !userAuthInfo.memberId) {
      await initMember(userAuthInfo, next, to)
    } else {
      await checkIsEatIn(to, next)
    }
  } else {
    let isLoggedIn = liff.isLoggedIn()
    if (isLoggedIn) {
      liff.getProfile()
        .then(async profile => {
          if (typeof profile.pictureUrl !== 'undefined') {
            sessionStorage.setItem('pictureUrl', profile.pictureUrl)
          } else {
            // TODO
            sessionStorage.setItem('pictureUrl', '')
          }
          sessionStorage.setItem('displayName', profile.displayName)
          // userAuthInfo
          let userAuthInfo = {}
          userAuthInfo.userName = profile.displayName
          userAuthInfo.userImg = profile.pictureUrl
          userAuthInfo.platformId = process.env.VUE_APP_LIFF_ID
          let liffUserId = profile.userId
          userAuthInfo.openId = liffUserId
          sessionStorage.setItem('openId', liffUserId)
          sessionStorage.setItem('userAuthInfo', JSON.stringify(userAuthInfo))
          let isCallInit = sessionStorage.getItem('statusInit')
          let memberIdSession = sessionStorage.getItem('memberId')
          let userAuthInfoJson = sessionStorage.getItem('userAuthInfo')
          if (userAuthInfoJson) {
            userAuthInfoJson = JSON.parse(userAuthInfoJson)
          }
          if (isCallInit || memberIdSession) {
            await checkIsEatIn(to, next)
          } else {
            sessionStorage.setItem('statusInit', 1)
            await initMember(userAuthInfo, next, to)
          }
        })
        .catch((err) => {
          next()
        })
    } else {
      setTimeout(() => { // 设置延迟执行
        getProfile(to, next)
      }, 1000)
    }
  }
}

async function initMember (userAuthInfo, next, to) {
  let requestData = {
    openId: userAuthInfo.openId,
    avatarUrl: userAuthInfo.userImg,
    nickName: userAuthInfo.userName
  }
  await post('/mo/member/initMember', requestData)
    .then((response) => {
      if (response.code === 200) {
        let memberId = response.data
        sessionStorage.setItem('memberId', memberId)
        let userAuthInfoJson = sessionStorage.getItem('userAuthInfo')
        if (userAuthInfoJson) {
          userAuthInfo = JSON.parse(userAuthInfoJson)
          userAuthInfo.memberId = memberId
          sessionStorage.setItem('userAuthInfo', JSON.stringify(userAuthInfo))
          sessionStorage.removeItem('statusInit')
          checkIsEatIn(to, next)

          let paramPartner = {
            openId: userAuthInfo.openId,
            personName: userAuthInfo.userName
          };

          userApi.syncStampDataFromFa(paramPartner);
        } else {
          userAuthInfo.memberId = memberId
          commonClass.getUserAuthInfo(userAuthInfo, next)
        }
      } else {
        sessionStorage.removeItem('statusInit')
      }
    },
    err => {
      sessionStorage.removeItem('statusInit')
    })
}

function getSysMStore () {
  let storeId = sessionStorage.getItem('storeId')
  if (storeId) {
    let storeData = sessionStorage.getItem('storeData')
    if (storeData) {
      storeData = JSON.parse(storeData)
      if (storeId !== storeData.storeId) {
        getSysMStoreInfo(storeId)
      }
    } else {
      getSysMStoreInfo(storeId)
    }
  }
}

function getSysMStoreInfo (storeId) {
  if (storeId) {
    let par = {
      storeId: storeId
    }
    post('/mo/sysMStore/getSysMStore', par).then((res) => {
      if (res) {
        sessionStorage.setItem('storeId', res.storeId)
        sessionStorage.setItem('storeName', res.storeName)
        sessionStorage.setItem('storeData', JSON.stringify(res))
      }
    })
  }
}
